import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Tab, Box, Typography } from "@material-ui/core";
import TabPanel from "@material-ui/lab/TabPanel";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import { useSettingStyles } from "../../../Util/CSS/SettingStyles/SettingsStyles";
import GeneralSettings from "./GeneralSettings/GeneralSettings";
import RestaurantLicenseApiKeysComp from "./LicenseApiKeys/LicenseApiKeys";
import Orders from "./LiveOrders/Orders";
import { useErrorHandler } from "react-error-boundary";
import { AuthContext } from "../../../Context/Auth";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { RestaurantAction } from "../../../Store/Reducers/Restaurant-reducer";
import OpenSnackbar from "../../../Shared/OpenSnackbar";
import { PrimaryButton } from "../../../Shared/Buttons";
import { Auth } from "aws-amplify";
import CreateHost from "cross-domain-storage/host";

const guest = window.location.host.includes("local")
  ? "http://localhost:3000"
  : process.env.REACT_APP_CORPORATE_PATH;
CreateHost([
  {
    origin: `${guest}`,
    allowedMethods: ["get", "set", "remove"],
  },
]);
const RestaurantDetails = () => {
  const { restaurantData } = useSelector((state) => state.Restaurant);
  const dispatch = useDispatch();
  const { id } = useParams();
  const classes = useSettingStyles();
  const [value, setValue] = useState("1");
  const [userId, setUserId] = useState("");
  const [IdToken, setIdToken] = useState("");

  let currIndex;
  restaurantData.map((item, index) => {
    if (item.id === id) {
      currIndex = index;
    }
  });
  const { user } = useContext(AuthContext);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    open: false,
    message: "",
    type: "",
  });
  let restName = settings?.generalSettings?.basic?.restaurant_name;
  let rName = restName && restName.replace(/ /g, "-");
  const [isValid, setIsValid] = useState({ valid: true, error: "" });
  const handleSnackbarOpen = (message, type) => {
    let obj = {
      open: true,
      message,
      type,
    };
    setSnackbarDetails(obj);
  };
  const snackBarCloseHandler = (value) => {
    setSnackbarDetails({ ...snackbarDetails, open: value });
  };
  const errorHandler = useErrorHandler();

  useEffect(() => {
    fetchSettings();
    Auth.currentSession()
      .then((data) => {
        if (data) {
          // data.accessToken.payload.username
          setIdToken(data.getIdToken().getJwtToken());
          // history.push(inMemRoute);
          setUserId(data.accessToken.payload.username);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_URL}restaurant/setting/${id}/super`
      );
      if (resp.data.settings) {
        setSettings(resp?.data?.settings);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        handleSnackbarOpen(error.response.data.error, "errorDark");
      }
      if (error.message) {
        handleSnackbarOpen(error.message, "errorDark");
      }
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const postSettings = async (body) => {
    try {
      if (settings.paymentSettings.payment_types.pay_by_card) {
        const cards = settings.paymentSettings.cards_accepted;
        if (
          !cards.american_express &&
          !cards.discover &&
          !cards.mastercard &&
          !cards.visa
        ) {
          setLoading(false);
          handleSnackbarOpen(`please select a card for payment`, "errorDark");
          return;
        }
      } else if (
        !settings.paymentSettings.payment_types.pay_by_card &&
        !settings.paymentSettings.payment_types.pay_by_cash
      ) {
        setLoading(false);
        handleSnackbarOpen(
          `Please select atleast one payment method`,
          "errorDark"
        );
        return;
      }
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}restaurant/setting/general/${id}`,

        body
      );

      if (res) {
        handleSnackbarOpen(`Settings details saved ✅`, "successDark");
        const { phone_number, restaurant_name, slug } =
          settings.generalSettings.basic;
        const currItem = {
          ...restaurantData[currIndex],
          restaurantName: restaurant_name,
          contactNumber: phone_number,
          slug,
        };
        if (currIndex) {
          dispatch(
            RestaurantAction.editRestaurant({
              index: currIndex,
              newItem: currItem,
            })
          );
        }
        console.log(body, settings);
        setSettings({});
        fetchSettings();
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        handleSnackbarOpen(error.response.data.error + "err1", "errorDark");
        return;
      }
      if (error?.message) {
        handleSnackbarOpen(error.message + "errr2", "errorDark");
        return;
      }
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!isValid.valid) {
      handleSnackbarOpen(
        isValid.error + "djckdkcmdkmcdkcmdkcmkdmck",
        "errorDark"
      );
      return;
    }
    setLoading(true);
    if (settings && settings.generalSettings.gateway_info.length === 0) {
      let obj = { ...settings };
      obj.paymentSettings.payment_types.pay_by_card = false;
      let cards = { ...obj.paymentSettings.cards_accepted };
      for (let key in cards) {
        cards[key] = false;
      }
      obj.paymentSettings.cards_accepted = cards;
      setSettings(obj);
    }
    // console.log(settings.generalSettings.gateway_info.length)
    const body = JSON.stringify({
      settings: settings,
    });

    let count = 0;
    settings.generalSettings.gateway_info.map((value) => {
      if (value.in_use === true) {
        count++;
      }
    });
    const payByCard = settings?.paymentSettings?.payment_types?.pay_by_card;
    if (payByCard && count === 0) {
      setLoading(false);
      handleSnackbarOpen(`please enable payment gateway`, "errorDark");
      return;
    } else if (count > 1) {
      setLoading(false);
      handleSnackbarOpen(`please enable only one payment gateway`, "errorDark");
      return;
    }
    postSettings(body);
  };

  useEffect(() => {
    if (
      settings &&
      settings.generalSettings &&
      settings.generalSettings.gateway_info &&
      settings.generalSettings.gateway_info.length === 0
    ) {
      let obj = { ...settings };
      obj.paymentSettings.payment_types.pay_by_card = false;
      let cards = { ...obj.paymentSettings.cards_accepted };
      for (let key in cards) {
        cards[key] = false;
      }
      obj.paymentSettings.cards_accepted = cards;
      setSettings(obj);
    }
  }, [settings?.generalSettings?.gateway_info]);

  const RestaurantDashboardHandler = () => {
    try {
      if (settings.generalSettings?.restaurant_api_key?.api_key) {
        CreateHost([
          {
            origin: `${guest}`,
            allowedMethods: ["get", "set", "remove"],
          },
        ]);
        const email = settings?.generalSettings.basic.email_id;
        let apikey = settings?.generalSettings?.restaurant_api_key?.api_key;
        localStorage.setItem("restName", restName);
        localStorage.setItem("email", email);
        localStorage.setItem("apikey", apikey);
        localStorage.setItem("mode", "superadmin");
        localStorage.setItem("idToken", IdToken);
        let clientId = process.env.REACT_APP_USER_POOL_CLIENT;
        let arrSharedValue = [
          `${localStorage.getItem(`apikey`)}`,
          `${localStorage.getItem(`restName`)}`,
          `${localStorage.getItem(`mode`)}`,
          `${localStorage.getItem(`amplify-signin-with-hostedUI`)}`,
          `${localStorage.getItem(
            `CognitoIdentityServiceProvider.${clientId}.${userId}.idToken`
          )}`,
          `${localStorage.getItem(
            `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`
          )}`,

          `${localStorage.getItem(
            `CognitoIdentityServiceProvider.${clientId}.${userId}.clockDrift`
          )}`,
          `${localStorage.getItem(
            `CognitoIdentityServiceProvider.${clientId}.${userId}.accessToken`
          )}`,
          `${localStorage.getItem(
            `CognitoIdentityServiceProvider.${clientId}.${userId}.userData`
          )}`,
          `${localStorage.getItem(
            `CognitoIdentityServiceProvider.${clientId}.${userId}.refreshToken`
          )}`,
        ];
        localStorage.setItem("sharedStorage", JSON.stringify(arrSharedValue));
        window.open(`${guest}/admin-login/${userId}/${rName}`);
      } else {
        handleSnackbarOpen(
          "Your restaurant settings has not been updated yet. So, please save the setting and then proceed",
          "errorDark"
        );
      }
    } catch (err) {
      console.log("we got error", err);
    }
  };

  return (
    <>
      <Box
        position="fixed"
        style={{
          textAlign: "center",
          zIndex: 3000,
          top: 17,
          left: 200,
          right: 200,
          fontSize: "24px",
          color: "#445B6E",
        }}
      >
        <Typography variant="p">
          {settings?.generalSettings?.basic?.restaurant_name || ""}
        </Typography>
      </Box>
      <TabContext value={value}>
        <Box>
          <Box className={classes.flexBtw}>
            <TabList onChange={handleChange} aria-label="Tabs">
              <Tab aria-label="settingTab" label="Settings" value="1" />
              <Tab
                aria-label="licenseKeyTab"
                label="License Api Keys"
                value="2"
              />
              <Tab aria-label="OrderTab" label="Orders" value="3" />
            </TabList>
            <PrimaryButton
              handleClick={RestaurantDashboardHandler}
              testId={`access_rest_dash_btn`}
              size="medium"
            >
              Restaurant Dashboard
            </PrimaryButton>
          </Box>
          <TabPanel value="1">
            <GeneralSettings
              classes={classes}
              settings={settings}
              setSettings={setSettings}
              loading={loading}
              setLoading={setLoading}
              handleSubmit={handleSubmit}
              errorHandler={errorHandler}
              fetchSettings={fetchSettings}
              isValid={isValid}
              setIsValid={setIsValid}
              handleSnackbarOpen={handleSnackbarOpen}
            />
          </TabPanel>
          <TabPanel value="2">
            <RestaurantLicenseApiKeysComp
              classes={classes}
              settings={settings}
              setSettings={setSettings}
              loading={loading}
              setLoading={setLoading}
              handleSubmit={handleSubmit}
              errorHandler={errorHandler}
              fetchSettings={fetchSettings}
              isValid={isValid}
              setIsValid={setIsValid}
              handleSnackbarOpen={handleSnackbarOpen}
            />
          </TabPanel>
          <TabPanel value="3">
            <Orders classes={classes} />
          </TabPanel>
        </Box>
      </TabContext>
      {snackbarDetails.open && (
        <OpenSnackbar
          message={snackbarDetails.message}
          type={snackbarDetails.type}
          open={snackbarDetails.open}
          setOpen={snackBarCloseHandler}
          vertical="bottom"
          horizontal="center"
        />
      )}
    </>
  );
};

export default RestaurantDetails;
